import {REST_METHODS} from '@/src/app/constants/api';
import {ORDER_FILTER, SEARCH_FILTERS} from '@/src/app/constants/search';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

const getContinueWatching = (locale) => {
  const param = [
    {
      name: SEARCH_FILTERS.PER_PAGE,
      value: '10',
    },
    {
      name: SEARCH_FILTERS.OFFSET,
      value: 0,
    },
    {
      name: SEARCH_FILTERS.ORDER,
      value: ORDER_FILTER.DESC,
    },
    {
      name: SEARCH_FILTERS.LANGUAGE,
      value: locale,
    },
  ];

  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.GET,
    path: `/api/v1/courses/watched_courses`,
    queryParams: param,
  });
};

export default getContinueWatching;
